import React from 'react';
import { useQuery, useParameterizedQuery } from 'react-fetching-library';
import { CalendarImpl } from './slots-control/CalendarImpl';
import { getActivitiesAction, getTimedSlotsControlAction } from '../../../services/request';
import { FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';

export const SlotsControlRecord = () => {
  const { loading, payload, error } = useQuery(getActivitiesAction(null, 'OPTIONS'));
  const { query, loading: timedSlotsLoading } = useParameterizedQuery(getTimedSlotsControlAction);
  const [allActivities, setAllActivities] = React.useState([]);
  const [allResorts, setAllResorts] = React.useState([]);
  const [timedSlotsControls, setTimedSlotsControls] = React.useState([]);
  const [selectedResort, setSelectedResort] = React.useState(null);

  React.useEffect(() => {
    if (!loading && !error) {
      setAllActivities(payload.actions.GET.activities.choices);
      setAllResorts(payload.actions.GET.resort.choices);
      setSelectedResort(payload.actions.GET.resort.choices[0].value);

    }
  }, [loading]);

  React.useEffect(() => {
    if (!selectedResort) {
      return undefined;
    }
    (async () => {
      const { payload, error, loading: qLoading } = await query(null, 'GET', selectedResort);

      if (!error && !qLoading) {
        setTimedSlotsControls(payload.results);
      }
    })();
  }, [selectedResort]);


  return (
    <Stack sx={{ opacity: timedSlotsLoading ? 0.5 : 1 }}>
      <RadioGroup
        sx={{ ml: 1 }}
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={selectedResort}
        onChange={e => setSelectedResort(e.target.value)}
      >
        {allResorts.map((resort, key) => <FormControlLabel key={key} value={resort.value} control={<Radio />} label={resort.label} />
        )}
      </RadioGroup>

      {timedSlotsControls && <CalendarImpl allActivities={allActivities} timedSlotsControls={timedSlotsControls} selectedResort={selectedResort} />}
    </Stack>
  );
};
